import AssetTreeList from "../components/asset-tree/AssetTree";

const AssetTreePage = () => {
  return (
    <>
      <AssetTreeList />
    </>
  );
};

export default AssetTreePage;
